'use client';
import React from 'react';
import DashboardLayout from '@/components/DashboardLayout';
import AdminComplaintsTable from '@/app/admin-dashboard/components/AdminComplaintsTable';

export default function AdminComplaintsPage() {
  return (
    <DashboardLayout role="admin">
      <div className="space-y-6">
        <div>
          <h1 className="text-2xl font-extrabold text-foreground">Complaints</h1>
          <p className="text-sm text-muted-foreground mt-0.5">Review and resolve customer complaints</p>
        </div>
        <AdminComplaintsTable />
      </div>
    </DashboardLayout>
  );
}
